import { Overlay } from "@albelli/image-list-view"
import "./ImagePreview.css"
import LeftArrow from "@albelli/photoselector/lib/ImagePicker/Graphic/left-white-arrow.svg"
import RightArrow from "@albelli/photoselector/lib/ImagePicker/Graphic/right-white-arrow.svg"
import Close from "@albelli/photoselector/lib/ImagePicker/Graphic/close-white.svg"
import { throttle, SelectionManager, Swipe } from "@albelli/photoselector"

class ImagePreview {
  private popup = document.createElement("div")
  public selections: any = {}
  public items: any[] = []
  public currentImage: any = {}
  public isSelected = false

  constructor() {
    this.resizeHandler = this.resizeHandler.bind(this)
    this.keydownHandler = this.keydownHandler.bind(this)
  }

  openPreview() {
    document.body.appendChild(this.popup)
  }

  closePreview() {
    document.body.removeChild(this.popup)
  }

  goto(index: number) {
    const gotoIndex = this.items.indexOf(this.currentImage) + index
    this.currentImage = this.items[gotoIndex] || this.currentImage
    this.isSelected = this.selections.isSelected(this.currentImage)
    this.render()
  }

  addPhotoToSelection() {
    this.isSelected ? this.selections.deselect(this.currentImage) : this.selections.select(this.currentImage)

    this.isSelected = !this.isSelected
    this.render()
  }

  resizeHandler() {
    return throttle(() => this.render())
  }

  keydownHandler(e) {
    switch (e.key) {
      case "Escape":
        return this.closePreview()
      case "ArrowLeft":
        return this.goto(-1)
      case "ArrowRight":
        return this.goto(1)
      case "Enter":
        return this.addPhotoToSelection()
      case " ":
        return this.addPhotoToSelection()
    }

    e.stopPropagation()
    e.preventDefault()
  }

  addEventListener() {
    this.popup.onclick = (e: any) => {
      switch (e.target.id) {
        case "close":
          return this.closePreview()
        case "photoselector-image-overlay":
          return this.closePreview()
        case "prev":
          return this.goto(-1)
        case "next":
          return this.goto(1)
        case "frame":
          return this.addPhotoToSelection()
        default:
          return this.addPhotoToSelection()
      }
    }

    window.addEventListener("keydown", this.keydownHandler)

    window.addEventListener("resize", this.resizeHandler)

    const swipe = new Swipe(
      () => this.goto(1),
      () => this.goto(-1)
    )
    swipe.addEventListener()
  }

  removeEventListeners() {
    window.removeEventListener("resize", this.resizeHandler)
    window.removeEventListener("keydown", this.keydownHandler)
  }

  render() {
    const currentIndex = this.items.indexOf(this.currentImage)
    const prevStyle = currentIndex === 0 ? "display: none" : "display: block"
    const nextStyle = currentIndex === this.items.length - 1 ? "display: none" : "display: block"
    const deselectStyle = !this.isSelected ? "display: none" : "display:block"
    const selectStyle = this.isSelected ? "display: none" : "display:block"

    let width = 0
    let height = 0
    const margin = window.innerWidth * 0.07
    let widthRatio = window.innerWidth / this.currentImage.size.width
    let heightRatio = window.innerHeight / this.currentImage.size.height

    if (this.currentImage.size.height * widthRatio > window.innerHeight) {
      height = window.innerHeight - margin
      heightRatio = height / this.currentImage.size.height
      width = this.currentImage.size.width * heightRatio
    } else if (this.currentImage.size.width * heightRatio > window.innerWidth) {
      width = window.innerWidth - margin
      widthRatio = width / this.currentImage.size.width
      height = this.currentImage.size.height * widthRatio
    } else {
      height = this.currentImage.size.height * widthRatio - margin
      width = this.currentImage.size.width * widthRatio - margin
    }

    this.popup.innerHTML = `<div id='photoselector-image-overlay' class='photoselector-image-preview'>
          <div class='photoselector-close-btn'>
            <img src='${Close}' id='close' class='icon form-error extra-small'/>
          </div>
          <img id='prev' class='photoselector-left-arrow' src='${LeftArrow}' style='${prevStyle}'/>
          <div class='photoselector-image-container' style='height:${height}px; width:${width}px'>
            <div class="photoselector-image-preview-selected-icon">
              <div style="${deselectStyle}" class="photoselector-deselect-all photoselector-selection-overlay-big"></div>
              <div style="${selectStyle}" class="photoselector-select photoselector-selection-overlay-big"></div>
            </div>
            <img src='${this.currentImage.urlPreview}' />
          </div>
          <img id='next' class='photoselector-right-arrow' src='${RightArrow}' style='${nextStyle}'/>
      </div>`
  }
}

export function makeImagePreviewOverlay(getItems: () => any[], selections: SelectionManager): Overlay {
  const imagePreview = new ImagePreview()
  const noop = () => {
    /* IGNORE */
  }
  return (item: any, img: HTMLElement) => {
    if (!item.urlPreview) return noop
    const eye = document.createElement("i")
    eye.className = "photoselector-image-preview-icon"
    eye.setAttribute("data-tam", "image-preview-icon")
    img.appendChild(eye)

    eye.onclick = (e: any) => {
      imagePreview.selections = selections
      imagePreview.items = getItems()
      imagePreview.currentImage = item
      imagePreview.isSelected = selections.isSelected(item)
      imagePreview.render()
      imagePreview.openPreview()
      imagePreview.addEventListener()

      e.stopImmediatePropagation()
    }

    return () => {
      if (eye.parentNode === img) {
        img.removeChild(eye)
      }

      imagePreview.removeEventListeners()
    }
  }
}
export default makeImagePreviewOverlay
